import { render, staticRenderFns } from "./PlaceSelect.vue?vue&type=template&id=4ffc53d7&"
import script from "./PlaceSelect.vue?vue&type=script&lang=ts&"
export * from "./PlaceSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports